import { render, staticRenderFns } from "./MyExams.vue?vue&type=template&id=764d1b8c&scoped=true&"
import script from "./MyExams.vue?vue&type=script&lang=js&"
export * from "./MyExams.vue?vue&type=script&lang=js&"
import style0 from "./MyExams.vue?vue&type=style&index=0&id=764d1b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764d1b8c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VDivider,VIcon,VImg})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('764d1b8c')) {
      api.createRecord('764d1b8c', component.options)
    } else {
      api.reload('764d1b8c', component.options)
    }
    module.hot.accept("./MyExams.vue?vue&type=template&id=764d1b8c&scoped=true&", function () {
      api.rerender('764d1b8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/MyExams/MyExams.vue"
export default component.exports